import Axios from "axios";
import {
  SET_PROPOSALS_ROUTES_LIST,
  UNSET_PROPOSALS_ROUTES_LIST,
} from "@/store/mutation-types";
import {
  saveUpdateSalesProposals,
  getSalesProposalsList,
  getSalesProposalbyId as getProposalByIdApi,
  saveUpdateActivityLogsProposals as saveUpdateActivityLogsProposalsApi,
} from "@/store/api";
// initial state
const state = {
  getSalesProposalsList: [],
  editingProposal: null,
  viewingProposal: null,
};

const getters = {
  getSalesProposalsList(state) {
    return state.getSalesProposalsList;
  },
  getViewingProposal: (state) => state.viewingProposal,
};

const mutations = {
  [SET_PROPOSALS_ROUTES_LIST](state, data) {
    state.getSalesProposalsList = data;
  },
  [UNSET_PROPOSALS_ROUTES_LIST](state) {
    state.getSalesProposalsList = [];
  },
  setEditingProposal(state, requisition) {
    state.editingProposal = requisition;
  },
  setViewingProposal(state, proposal) {
    state.viewingProposal = proposal;
  },
};

const actions = {
  saveUpdateSalesProposals({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSalesProposals, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  saveUpdateActivityLogsProposals({ commit }, { id, data }) {
    const url = `${saveUpdateActivityLogsProposalsApi}/${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(url, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSalesProposalsList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSalesProposalsList, data)
        .then(function (response) {
          commit("SET_PROPOSALS_ROUTES_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_PROPOSALS_ROUTES_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getSalesProposalbyId({ commit }, id) {
    const getSalesProposalbyId = `${getProposalByIdApi}/${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getSalesProposalbyId)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
